import React from "react";
import { Alert, Row, Col } from "reactstrap";
import { Icon } from "@cadmakers-ui/icons";
import { Link } from "react-router-dom";
import styles from "../Styles/ForbiddenDisplay.module.scss";
import { appPaths } from "..";
import iconStyles from "../Styles/Icons.module.scss";

type Props = {
  description: string;
};

/* eslint class-methods-use-this: ["error", { "exceptMethods": ["getSubmitBugReportUrl"] }] */
export default class ForbiddenDisplay extends React.Component<Props> {
  getSubmitBugReportUrl(): string {
    const encodedUrlOfThisPage = encodeURIComponent(window.location.href);

    return `${appPaths.feedback.submitFeedback}?type=bug&app=CMF&link=${encodedUrlOfThisPage}&errorCode=403`;
  }

  render() {
    return (
      <Alert className="alert-warning">
        <Row>
          <Col colSpan={8}>
            <p>
              <b>403: Forbidden</b>
            </p>
            <p>{this.props.description}</p>
            <small>
              <span>If you see this message in error,</span>
              &nbsp;
              <Link to={this.getSubmitBugReportUrl()}>click here to submit a Bug Report</Link>
            </small>
          </Col>
          <Col colSpan={4} className={styles.forbiddenIconCol}>
            <Icon
              appName="GeneralLayout"
              assetName="GENERAL_L_Lock"
              className={iconStyles.smallIcon}
            />
          </Col>
        </Row>
      </Alert>
    );
  }
}
